<template>
    <div class="math-lessons-page">
        <!--<chapter tag="h1" class="ribbon">Оберіть предмет</chapter>-->
        <!--<chapter tag="h1" class="ribbon">Предмети</chapter>-->
        <chapter tag="h1" class="ribbon">Предмети</chapter>
        <math-lessons></math-lessons>
    </div>
</template>

<script>
    import Vue from 'vue';
    Vue.component('math-lessons', () => import(/* webpackChunkName: "math-lessons" */ '~/components/math-lessons'));

    export default {
        name: 'math-lessons-page',
        components: {}
    }
</script>
